import { RouteConfig } from 'vue-router';

const ProjectList = () => import(/* webpackChunkName: "Project" */  './views/project-list/project-list.vue');
const ProjectCreateFirst = () => import(/* webpackChunkName: "Project" */  './views/project-create-first/project-create-first.vue');
const ProjectCreateSecond = () => import(/* webpackChunkName: "Project" */  './views/project-create-second/project-create-second.vue');
const ProjectCreateThird = () => import(/* webpackChunkName: "Project" */  './views/project-create-third/project-create-third.vue');
const ResearchListFolder = () => import(/* webpackChunkName: "ResearchList" */ './modules/research-list/research-list-folder/research-list-folder.vue');
const ImportPatient = () => import(/* webpackChunkName: "ResearchList" */ './modules/research-list/import-patient/import-patient.vue');
const ImportFromSizhen = () => import(/* webpackChunkName: "ResearchList" */ './modules/research-list/import-from-sizhen/import-from-sizhen.vue');
const ResearchListCompose = () => import(/* webpackChunkName: "ResearchList" */ './modules/research-list/research-list-compose/research-list-compose.vue');
const MemberManage = () => import(/* webpackChunkName: "ResearchList" */ './modules/research-list/member-manage/member-manage.vue');
const HospitalManage = () => import(/* webpackChunkName: "ResearchList" */ './modules/research-list/hospital-manage/hospital-manage.vue');
const CrfList = () => import(/* webpackChunkName: "CrfList" */ './modules/crf-list/crf-list.vue');
const CrfStatistics = () => import(/* webpackChunkName: "CrfStatistics" */ './modules/crf-statistics/crf-statistics.vue');
const CrfEdit = () => import(/* webpackChunkName: "CrfEdit" */ './modules/crf-edit/crf-edit.vue');
const CrfPublish = () => import(/* webpackChunkName: "CrfPublish" */ './modules/crf-publish/crf-publish.vue');
const CollectProgressOverview = () => import(/* webpackChunkName: "CollectProgress" */ './modules/collect-progress/collect-progress-overview/collect-progress-overview.vue');
const AnalysisReportFolder = () => import(/* webpackChunkName: "AnalysisReport" */ './modules/analysis-report/analysis-report-folder/analysis-report-folder.vue');
const DataFilterFolder = () => import(/* webpackChunkName: "DataFilter" */ './modules/data-filter/data-filter-folder/data-filter-folder.vue');
const CreateDataTable = () => import(/* webpackChunkName: "DataFilter" */ './modules/data-filter/create-data-table/create-data-table.vue');

const routers: RouteConfig[] = [
    {
        path: 'project-list',
        component: ProjectList
    },
    {
        path: 'project-create-first',
        component: ProjectCreateFirst
    },
    {
        path: 'project-create-first/:project_id',
        component: ProjectCreateFirst
    },
    {
        path: 'project-create-second/:project_id',
        component: ProjectCreateSecond
    },
    {
        path: 'project-create-third/:project_id',
        component: ProjectCreateThird
    },
    // 研究队列
    {
        path: 'research-list-folder/:project_id',
        component: ResearchListFolder,
        meta: {
            keepAlive: true
        }
    },
    {
        path: 'import-patient',
        component: ImportPatient
    },
    {
        path: 'import-from-sizhen',
        component: ImportFromSizhen
    },
    {
        path: "research-list-compose",
        component: ResearchListCompose
    },
    {
        path: "member-manage/:project_id",
        component: MemberManage
    },
    {
        path: "hospital-manage/:project_id",
        component: HospitalManage
    },
    // CRF量表
    {
        path: "crf-list",
        component: CrfList
    },
    {
        path: "crf-statistics",
        component: CrfStatistics
    },
    {
        path: "crf-edit",
        component: CrfEdit
    },
    {
        path: "crf-publish",
        component: CrfPublish
    },
    // 采集进度
    {
        path: "collect-progress-overview/:project_id",
        component: CollectProgressOverview
    },
    // 分析报告
    {
        path: "analysis-report-folder/:project_id",
        component: AnalysisReportFolder
    },
    // 数据筛选
    {
        path: "data-filter-folder/:project_id",
        component: DataFilterFolder
    },
    {
        path: "create-data-table/:project_id",
        component: CreateDataTable
    },
    {
        path: '',
        redirect: 'project-list'
    },
];

export default routers;

